import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ESubscriptionRestoreState, ISubscription, ITerminateSubscriptionPayload, TSubscriptionID } from './types';

export interface IManagePageState {
  started: boolean;
  subscriptions?: ISubscription[];
  restore: ESubscriptionRestoreState;
}

export const initialState: IManagePageState = {
  started: false,
  restore: ESubscriptionRestoreState.None,
};

export const statePropName = 'manage';

const manageSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    startManageApp(state: IManagePageState) {
      return {
        ...initialState,
      };
    },
    manageAppStarted(state: IManagePageState, action: PayloadAction<ISubscription[]>) {
      state.started = true;
      state.subscriptions = action.payload;
    },
    restoreSubscription(state: IManagePageState, action: PayloadAction<TSubscriptionID>) {
      state.restore = ESubscriptionRestoreState.Running;
    },
    restoreSubscriptionSuccess(state: IManagePageState) {
      state.restore = ESubscriptionRestoreState.Success;
    },
    restoreSubscriptionFailure(state: IManagePageState) {
      state.restore = ESubscriptionRestoreState.None;
    },
    restoreSubscriptionConfirm(state: IManagePageState) {
      state.restore = ESubscriptionRestoreState.None;
    },
    terminateSubscriptionRequest: {
      reducer(state: IManagePageState, action: PayloadAction<ITerminateSubscriptionPayload>) {
        // handle termination logic if needed
      },
      prepare(subscriptionId: TSubscriptionID, terminate = false) {
        return { payload: { subscriptionId, terminate } };
      },
    },
  },
});

export const ManageActions = manageSlice.actions;
export default manageSlice.reducer;
